import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const BarChart = () => {
  // Your provided data
  const chartData = {
    aiBoom: 95,
    cryptoShift: 85,
    greenTech: 90,
    spaceRace: 80,
    metaLife: 88,
    evSurge: 92,
    remoteWork: 75,
    healthAi: 94,
  };

  // Transform the object data into an array format suitable for Highcharts
  const categories = [
    "AI Boom",
    "Crypto Shift",
    "Green Tech",
    "Space Race",
    "Meta Life",
    "EV Surge",
    "Remote Work",
    "Health AI",
  ];
  const data = Object.values(chartData); // [10, 20, 30, ...]

  // Highcharts configuration
  const options = {
    chart: {
      type: "bar", // Bar chart
    },
    title: {
      text: "", // Title of the chart
    },
    xAxis: {
      categories: categories, // X-axis categories (statuses)
      title: {
        text: "Keyword / Topic",
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Counts",
        align: "high",
      },
      labels: {
        overflow: "justify",
      },
    },
    tooltip: {
      valueSuffix: " items",
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true, // Enable data labels on the bars
        },
      },
    },
    series: [
      {
        name: "Trend Intensity", // Series name
        data: data, // Data for the bars
        colorByPoint: true, // Assign different colors to each bar
      },
    ],
    credits: {
      enabled: false, // Disable the Highcharts.com watermark
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default BarChart;
